module.exports = __webpack_public_path__ + "workspace/static/img/accessMgmtTwo.c716a25.png";